module.exports = __webpack_public_path__ + "img/how-to-change-password-vpn-client.6a57083b.png";